<template>
  <page-view :title="false">
    <a-card :bordered="false">
      <div class="table-page-search-wrapper">
        <a-form-model layout="inline">
          <a-row :gutter="48">
            <a-col :md="8" :sm="24">
              <a-form-model-item label="管家名称"
                ><a-input
                  allowClear
                  v-model="queryParam.nickName"
                  placeholder="管家名称"
              /></a-form-model-item>
            </a-col>
            <a-col :md="8" :sm="24">
              <a-form-model-item label="手机号码"
                ><a-input
                  allowClear
                  v-model="queryParam.mobile"
                  placeholder="手机号码"
              /></a-form-model-item>
            </a-col>
            <template v-if="advanced">
              <a-col :md="8" :sm="24">
                <a-form-item label="管家编号"
                  ><a-input v-model="queryParam.userNo" placeholder="管家编号"
                /></a-form-item>
              </a-col>
            </template>
            <a-col :md="(!advanced && 8) || 24" :sm="24">
              <span
                class="table-page-search-submitButtons"
                :style="
                  (advanced && { float: 'right', overflow: 'hidden' }) || {}
                "
              >
                <a-button type="primary" @click="$refs.table.refresh(true)"
                  >查询</a-button
                >
                <a-button style="margin-left: 8px" @click="reset"
                  >重置</a-button
                >
                <a-button
                  v-if="userInfo.userType == '3'"
                  type="primary"
                  icon="plus"
                  style="margin-left: 8px"
                  @click="showModal"
                >
                  添加管家
                </a-button>
                <a @click="toggleAdvanced" style="margin-left: 8px">
                  {{ advanced ? "收起" : "展开" }}
                  <a-icon :type="advanced ? 'up' : 'down'" />
                </a>
              </span>
            </a-col>
          </a-row>
        </a-form-model>
      </div>

      <!-- 数据表格 -->
      <s-table
        ref="table"
        size="default"
        rowKey="id"
        :columns="columns"
        :data="loadData"
        showPagination="auto"
      >
        <span
          slot="action"
          slot-scope="text, record"
          v-if="userInfo.userType == '3'"
        >
          <template>
            <a-popconfirm
              title="确认删除?"
              @confirm="confirm(record)"
              okText="确认"
              cancelText="取消"
              ><a class="a-action">删除</a></a-popconfirm
            >
          </template>
        </span>
      </s-table>
    </a-card>

    <!-- 分配管家 -->
    <a-modal
      title="分配管家"
      v-model="modal.visible"
      @ok="allot"
      :confirm-loading="modal.submit"
    >
      <div style="padding-bottom: 20px;color: red;">
        注意：删除前需选择新管家替换当前管家的业务。
      </div>
      <a-select
        placeholder="请选择管家"
        style="width: 100%;"
        v-model="modal.formParam.newUserNo"
      >
        <a-select-option
          v-for="item in modal.tempKeeperList"
          :value="item.userNo"
          :key="item.userNo"
          >{{ item.nickName }}-{{ item.mobile }}</a-select-option
        >
      </a-select>
    </a-modal>

    <!-- 添加管家 -->
    <add-keeper ref="keeper" @success="success"></add-keeper>
  </page-view>
</template>

<script>
import { PageView } from "@/layouts";
import { STable } from "@/components";
import AddKeeper from "./AddKeeper.vue";
export default {
  components: {
    PageView,
    STable,
    AddKeeper
  },
  name: "KeeperList",
  data() {
    return {
      userInfo: {},
      keeperList: [],
      newKeeperList: [],
      advanced: false,
      queryParam: {},
      modal: {
        visible: false,
        submit: false,
        formParam: {
          userNo: "",
          newUserNo: undefined,
          merchantNo: ""
        },
        tempKeeperList: []
      },
      // 表头
      columns: [
        {
          title: "管家编号",
          dataIndex: "userNo"
        },
        {
          title: "管家名称",
          dataIndex: "userName"
        },
        {
          title: "手机号",
          dataIndex: "mobile"
        },
        {
          title: "性别",
          dataIndex: "sex"
        },
        {
          title: "修改人",
          dataIndex: "modifyUser"
        },
        {
          title: "修改时间",
          dataIndex: "modifyDatetime"
        },
        {
          title: "操作",
          dataIndex: "action",
          align: "left",
          scopedSlots: { customRender: "action" }
        }
      ],
      //加载数据方法 必须为 Promise 对象
      loadData: parameter => {
        return this.$http.roomBksApi
          .pageHouseMerchantKeeper(Object.assign(parameter, this.queryParam))
          .then(res => {
            return res.resultObject;
          });
      }
    };
  },
  created() {
    this.userInfo = this.$store.getters.userInfo;
    this.queryParam.merchantNo = this.userInfo.merchantNo;
    this.getKeeperList();
  },
  methods: {
    async getKeeperList() {
      let param = {};
      param.merchantNo = this.userInfo.merchantNo;
      this.$http.roomBksApi.findKeeperHelpDto(param).then(res => {
        if (res.result == 0) {
          this.keeperList = res.resultObject;
        }
      });
    },
    toggleAdvanced() {
      this.advanced = !this.advanced;
    },
    reset() {
      this.queryParam = {};
      this.queryParam.merchantNo = this.userInfo.merchantNo;
    },

    confirm(data) {
      this.modal.formParam.userNo = data.userNo;
      this.modal.formParam.merchantNo = this.userInfo.merchantNo;
      this.modal.visible = true;
      this.modal.submit = false;
      this.modal.formParam.newUserNo = undefined;
      this.modal.tempKeeperList = [];
      for (let item of this.keeperList) {
        if (item.userNo != data.userNo) {
          this.modal.tempKeeperList.push(item);
        }
      }
    },
    allot() {
      if (!this.modal.formParam.newUserNo) {
        this.$message.error("请选择管家");
        return;
      }
      this.modal.submit = true;
      this.$http.roomBksApi.deleteKeeper(this.modal.formParam).then(res => {
        this.modal.submit = false;
        if (res.result == 0) {
          this.modal.visible = false;
          this.$refs.table.refresh(true);
          this.$message.success(res.msg);
          this.keeperList = this.modal.tempKeeperList;
          this.modal.formParam.newUserNo = undefined;
        }
      });
    },
    showModal() {
      this.$refs.keeper.showModal(this.userInfo.merchantNo);
    },
    success() {
      this.getKeeperList();
      this.$refs.table.refresh(true);
    }
  }
};
</script>

<style lang="less" scoped>
.operation-button {
  text-align: right;
}
</style>
